export default "__VITE_ASSET__jt1Jx8X2__"